export enum RouteNames {
  PLAY_MENU = "play-menu",
  DOJO = "dojo",
  DOJO_TRAINING_CONFIG = "dojo-training-config",
  DOJO_TEAM_SELECT = "dojo-team-select",
  DOJO_BATTLE = "dojo-battle",
  DOJO_SANDBOX = "dojo-sandbox",
  POKEMON_INFO = "pokemon-info",
  EGG_INFO = "egg-info",
  TEAM_LIST = "team-list",
  TEAM_EDIT = "team-edit",
  SHOP = "shop",
  INVENTORY_ITEMS = "inventory-items",
  INVENTORY_POKE = "inventory-poke",
  BREED = "breed",
  SEND_POKECOINS = "send-pokecoins",
  SEND_POKESHARDS = "send-pokeshards",
  SEND_ITEMS = "send-items",
  LEADERBOARD = "leaderboard",
  ARENA_TEAM_SELECT = "arena-team-select",
  DUEL_QUEUE = "duel-queue",
  BATTLE_TEST = "battle-test",
  PLAYER_PROFILE = "player-profile",
  PROFILE_SETTINGS = "profile-settings",
  // Raid routes
  RAID_START = "raid-start",
  RAID_SELECT = "raid-select",
  RAID_LOBBY = "raid-lobby",
  RAID_ACTIVE = "raid-active", // Unified route for all in-raid phases
  // Legacy campaign routes (separate feature)
  RAID_CAMPAIGN_SELECT = "raid-campaign-select",
  RAID_STAGE_SELECT = "raid-stage-select",
  // Dev routes
  DEV_RAID_INTRO = "dev-raid-intro",
  PICK_POKEMON = "pick-pokemon",
  // Ideas routes
  IDEA_BOARD = "idea-board",
  // Box routes
  BOX_LIST = "box-list",
  BOX_DETAILS = "box-details",
  // Collection routes
  COLLECTION_LIST = "collection-list",
  COLLECTION_DETAILS = "collection-details",
}
